<template>
  <div>
    <v-dialog
        v-model="dialog"
        width="600"
    >
      <v-card class="tw-px-4 md:tw-px-6">
        <card-title icon="mdi-shield-car">Request For Quote</card-title>
        <v-card-text class="tw-mt-2 md:tw-mt-5 tw-p-2 tw-bg-blue-100 tw-rounded-lg tw-text-center">
          <p>We currently do not offer insurance for this model online. For a quote and more details please call our Customer Experience team on 0730677000.
            <br> Alternatively, you can provide your Name and Mobile number below and our team will contact you</p>
        </v-card-text>

        <submit-contact insurance-type="private" @contact-form-submitted="closeModal" />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SubmitContact from '@/components/rfq/SubmitContact';
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'NoRfqModal',
  components: { CardTitle, SubmitContact },
  props: ['model'],
  data() {
    return {
      dialog: this.open,
    };
  },
  mounted() {
    this.$root.$on('open-modal-rfq', () => {
      this.dialog = true;
    });
  },
  methods: {
    closeModal() {
      this.dialog = false;
    },
  },
};
</script>
